import * as React from "react";
import { CountryCode } from "./admin-gql";
export var NationalId = function (props) {
    return (React.createElement(React.Fragment, null, props.country === CountryCode.SE && props.nationalId
        ? props.nationalId.substr(0, 8) + "-" + props.nationalId.substr(8, 4)
        : props.nationalId));
};
//# sourceMappingURL=NationalId.js.map